import { useState, useCallback, useEffect } from "react";
import { NMAxiosInst } from "@neumetric/blueprint-lib/store";
import { NMWaitIndicator } from "@neumetric/blueprint-lib/components";
import { AuditorAssessmentStats } from "./Assessments";
import { AuditWise } from "./AuditDetails";

export function AuditorStats(props) {
  const {
    user,
    departments,
    dateRangeList,
    dateRange,
    selectedAudit,
    setSelectedAudit,
    mode,
    setAuditList,
    exportPayload,
  } = props;
  const [audits, setAudits] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const handleSaveAudits = useCallback((audits) => {
    setAudits(audits);
    setSelectedAudit(audits[0] ?? null);
    setIsLoading(false);
  }, [setSelectedAudit]);

  const effectiveRangeId =
  typeof dateRange === "string"
    ? dateRange
    : dateRange?.id || "last_365_days";
  useEffect(() => {
    if (mode !== "fusion") {
      setIsLoading(true);
      return undefined;
    }

    let cancelled = false;
    setIsLoading(true);
    async function loadAuditsForFusion() {
      try {
        const res = await NMAxiosInst.post("/centrals/dashboard", {
          date_range_type: effectiveRangeId,
        });
        if (cancelled) return;

        const list = Array.isArray(res?.audit_stat) ? res.audit_stat : [];
        const normalized = list.map((r, i) => ({
          id: r?.asmt_id ?? null,
          title: r?.title ?? `Audit ${i + 1}`,
          controls: Number(r?.controls ?? 0),
          compliant: Number(r?.compliant ?? 0),
          gap: Number(r?.gap ?? 0),
          exemption: Number(r?.exemption ?? 0),
          pending: Number(r?.pending ?? 0),
          score: Number(r?.score ?? 0),
        }));

        const deduped = Array.from(
          new Map(
            normalized.map((audit) => [
              audit.title?.trim().replace(/\s+/g, " ").toLowerCase(),
              audit,
            ])
          ).values()
        );

        setAudits(deduped);
        setSelectedAudit(deduped[0] ?? null);
        setIsLoading(false);
      } catch (err) {
        if (!cancelled) {
          console.error("Error loading audits for fusion mode:", err);
          setIsLoading(false);
        }
      }
    }

    loadAuditsForFusion();
    return () => {
      cancelled = true;
    };
  }, [mode, effectiveRangeId, setSelectedAudit]);

  // Automatically sync auditList
  useEffect(() => {
    setAuditList(audits);
  }, [audits, setAuditList]);

  return (
    <div className="o-auto">
      <div style={{ display: isLoading ? "none" : undefined }}>
        {((mode !== "fusion" && mode === "full") ||
          mode === "export_everything") && (
          <AuditorAssessmentStats
            handleSaveAudits={handleSaveAudits}
            user={user}
            dateRange={dateRange}
            dateRangeList={dateRangeList}
          />
        )}
        <AuditWise
          user={user}
          audits={audits}
          departments={departments}
          dateRange={dateRange}
          dateRangeList={dateRangeList}
          selectedAudit={selectedAudit}
          setSelectedAudit={setSelectedAudit}
          mode={mode}
          exportPayload={exportPayload}
        />
      </div>
      {isLoading && <NMWaitIndicator />}
      {mode === "full" && (
        <div style={{ paddingTop: "100px" }}>
          <hr className="nm-hr nm-hr--center" />
        </div>
      )}
    </div>
  );
}
